import * as React from 'react';
import { SVGProps } from 'react';

const IconExpandWidthSideSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16 6h5v12h-5v-2h3V8h-3V6Z" />
  </svg>
);
export default IconExpandWidthSideSizeM;
